import { render, staticRenderFns } from "./PopupGlimsFormCause2.vue?vue&type=template&id=19bd6ecc&"
import script from "./PopupGlimsFormCause2.vue?vue&type=script&lang=js&"
export * from "./PopupGlimsFormCause2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports